import { api } from "@/lib/api";
import { Activity } from "@/types";

interface ActivityApiResponse {
  status: string;
  message: string;
  data: Activity[];
}

export const activityService = {
  async getAllActivities(): Promise<Activity[]> {
    const response = await api.get<ActivityApiResponse>("/activity");
    return response.data.data;
  },
};